import { useCallback, useState, useEffect } from 'react'
import { NavLink, useNavigate } from 'react-router-dom'

import { DEFAULT_ANIMATION } from '../../lib/const'
import { removeAuth } from '../../lib/utils'
import httpClient from '../../httpClient'
import { usePendingPhotographersCount } from '../../stores'

import MuseaNewLogo from '../../images/MUSEA_Logo_2026.png'
import { ReactComponent as OrdersIcon } from '../../images/icons/NavDrawer/orders.svg'
import { ReactComponent as PhotographersIcon } from '../../images/icons/NavDrawer/photographers.svg'
import { ReactComponent as PricingIcon } from '../../images/icons/NavDrawer/pricing.svg'
import { ReactComponent as CreditIcon } from '../../images/icons/NavDrawer/credit.svg'
import { ReactComponent as AccountIcon } from '../../images/icons/NavDrawer/account.svg'
import { ReactComponent as LogoutIcon } from '../../images/icons/NavDrawer/logout.svg'
import { ReactComponent as ExpandIcon } from '../../images/icons/NavDrawer/expand.svg'
import { getCookie } from '../../lib/utils'

import NavItem from './NavItem'

const NavDrawer = () => {
  const [isExpanded, setIsExpanded] = useState(true)
  const isAdmin = getCookie('isUserAdmin') === 'true'
  const { pendingCount: pendingPhotographersCount, fetchCounts } =
    usePendingPhotographersCount()
  const fetchPendingCount = useCallback(() => fetchCounts(['pending']), [fetchCounts])
  const navigate = useNavigate()
  const handleExpande = useCallback(() => setIsExpanded((prev) => !prev), [])
  const handleLogout = useCallback((e) => {
    e.preventDefault()
    removeAuth()
    navigate('/login')
  }, [])

  useEffect(() => {
    if (!isAdmin) return undefined

    fetchPendingCount()
  }, [fetchPendingCount, isAdmin])

  return (
    <div
      data-collapse="medium"
      role="banner"
      className="navbar w-nav"
      style={{
        width: isExpanded ? '215px' : '80px',
        transition: DEFAULT_ANIMATION,
      }}
    >
      <div className="div-block-58">
        <NavLink to="/" className="brand w-nav-brand">
          <img src={MuseaNewLogo} loading="lazy" alt="" className="logo-img" style={{ width: '65px' }} />
          <div
            data-w-id="4ed3bba0-20f4-ecdd-52a3-fa7ad124ba00"
            className="text-logo"
            style={{
              opacity: isExpanded ? '1' : '0',
              transition: DEFAULT_ANIMATION,
            }}
          >
            {/* <span className="text-span">MUSEA</span> */}
          </div>
        </NavLink>
      </div>
      <div className="div-block-6">
        <div className="w-layout-grid grid-sidebar">
          <NavItem to="/lab-orders" isExpanded={isExpanded} icon={OrdersIcon} label="Orders" />
          {isAdmin && (
            <>
              <NavItem to="/photographers" isExpanded={isExpanded} icon={PhotographersIcon} label="Photographers" >
                {pendingPhotographersCount > 0 && (
                  <span
                    className="photographers-pending-dot"
                    aria-label={`${pendingPhotographersCount} photographers pending approval`}
                  />
                )}
              </NavItem>
            </>
          )}
          <NavItem to="https://musealab.com/pricing" isExpanded={isExpanded} icon={PricingIcon} label="Pricing" />
          {/* <NavItem to="/credit" isExpanded={isExpanded} icon={CreditIcon} label="Credit" /> */}
        </div>
        <div>
          <div className="w-layout-grid grid-sidebar">
            <div className="div-block-40">
              <div className="div-block-2">
                <div className="line-divider" />
              </div>
              <div className="w-layout-grid grid-sidebar _2">
                <NavItem to="/account" isExpanded={isExpanded} icon={AccountIcon} label="Account" />
                <button
                  id="w-node-_4ed3bba0-20f4-ecdd-52a3-fa7ad124ba06-d124b9fc"
                  aria-current="page"
                  className="sidebar-button w-inline-block logout"
                  onClick={handleLogout}
                  onKeyPress={handleLogout}
                  type="button"
                >
                  <div className="img-order-summary-container">
                    <div className="icon w-embed">
                      <LogoutIcon />
                    </div>
                  </div>
                  <div
                    className="div-block"
                    style={{
                      transform: isExpanded
                        ? 'translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)'
                        : 'translate3d(-20px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg)',
                      transformStyle: 'preserve-3d',
                      transition: DEFAULT_ANIMATION,
                      width: isExpanded ? 'auto' : '0',
                      opacity: isExpanded ? '1' : '0',
                    }}
                  >
                    <div>Logout</div>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div data-w-id="16af4c97-cddb-68d0-8589-5c73ee4f8f4d" className="bottom-sidebar">
          <div
            role="button"
            onClick={handleExpande}
            onKeyPress={handleExpande}
            data-w-id="13d4cefa-2761-212e-aa74-f62eceb860ac"
            className="icon w-embed"
            style={{ transform: isExpanded ? 'rotate(180deg)' : 'none' }}
          >
            <ExpandIcon />
          </div>
        </div>
      </div>
      <div className="w-nav-button">
        <div className="w-icon-nav-menu" />
      </div>
    </div>
  )
}

export default NavDrawer
